import { ServicePartner } from "@rumble-it/common-lib/types/models/ServicePartner.interface";
import { Transfer } from "antd";
import type {
  GetProp,
  TableColumnsType,
  TableProps,
  TransferProps,
} from "antd";
import { Table } from "@/components/v2";

type TransferItem = GetProp<TransferProps, "dataSource">[number];
type TableRowSelection<T extends object> = TableProps<T>["rowSelection"];

interface TableTransferProps extends TransferProps<TransferItem> {
  dataSource: Partial<ServicePartner>[];
  columns: TableColumnsType<Partial<ServicePartner>>;
}

const filterOption = (input: string, item: Partial<ServicePartner>) => {
  const lowerInput = input.toLowerCase();
  return (
    (item.groupName?.toLowerCase().includes(lowerInput) ?? false) ||
    (item.name?.toLowerCase().includes(lowerInput) ?? false) ||
    (item.address?.city?.toLowerCase().includes(lowerInput) ?? false)
  );
};

export const ServicepartnerRootImportTableTransfer = ({
  columns,
  ...props
}: TableTransferProps) => {
  return (
    <Transfer
      showSelectAll={false}
      showSearch
      filterOption={filterOption}
      locale={{
        itemUnit: "hersteller",
        itemsUnit: "herstellers",
        searchPlaceholder: "Zoek een hersteller",
      }}
      style={{ width: "100%" }}
      {...props}
    >
      {({
        filteredItems,
        onItemSelect,
        onItemSelectAll,
        selectedKeys: listSelectedKeys,
      }) => {
        const rowSelection: TableRowSelection<TransferItem> = {
          onChange(selectedRowKeys) {
            onItemSelectAll(selectedRowKeys, "replace");
          },
          selectedRowKeys: listSelectedKeys,
        };

        return (
          <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={filteredItems}
            locale={{
              emptyText: "Geen herstellers gevonden",
              selectionAll: "Selecteer alles",
            }}
            size="small"
            onRow={(rowProps) => ({
              onClick: () =>
                onItemSelect(
                  rowProps.key,
                  !listSelectedKeys.includes(rowProps.key),
                ),
            })}
          />
        );
      }}
    </Transfer>
  );
};
